import { evaluateFlags, flagsClient, getDefinitions } from "@unleash/nextjs";
import Cookies from "js-cookie";

export const isFeatureEnabled = async (ctx, flagName) => {
  try {
    const definitions = await getDefinitions(ctx, {
      fetchOptions: {
        next: { revalidate: 15 },
        signal: AbortSignal.timeout(5000),
      },
    });
    const { toggles } = evaluateFlags(definitions);
    const flags = flagsClient(toggles);
    return flags.isEnabled(flagName);
  } catch (err) {
    console.warn(
      `Failed getting feature flags => \t Error Name: ${err.name} \t Error Message: ${err.message} \t Error Stack: ${err.stack}`,
    );
    return false;
  }
};

export const isFeatureCookieSet = flagName => {
  return Cookies.get(`x-feature-${flagName}`) === "true";
};

export const isFeatureCookiePresent = flagName => {
  return Cookies.get(`x-feature-${flagName}`) !== undefined;
};
